/* eslint-disable no-throw-literal */
/* eslint-disable no-empty */
import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import Stepper from 'react-stepper-horizontal';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import {Button, Form} from 'react-bootstrap';
import Select from 'react-select';
import {useStateWithCallbackLazy} from 'use-state-with-callback';
import {PfImage} from '@profabric/react-components';
import styled from 'styled-components';
import {logoutUser} from '@store/reducers/auth';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import ClockLoader from 'react-spinners/ClockLoader';
import {toast} from 'react-toastify';
import {Rating} from 'react-simple-star-rating';
import styles from 'src/pages/car/CSS/SurveyModal.module.css';
import MapAndInfo from '../MapAndInfo';
import Map from '../Map';
import PhotoStamp from '../PhotoStamp';
import DirectChat from '../DirectChat';
import SurveyModal from './ModalSurvey';
import * as AuthService from '../../../services/auth';
import {SelectedBox} from '../MapElement';
import ModalAddPicGps from './ModalAddPicGps';
import ModalAddPic from './ModalAddPic';

const tooltipArray = ['แย่', 'ควรปรับปรุง', 'พอใช้', 'ดี', 'ดีมาก'];

export default function ModalItem(props) {
  const user = useSelector((state) => state.auth.currentUser);
  useEffect(() => {
    if (Object.keys(props.dropdowns).length !== 0) {
      console.log(props.dropdowns);
      setDropdownCostcenter(props.dropdowns.COSTCENTER);
      setDropdownCompany(props.dropdowns.COMPANY);
      setDropdownCarPublic(props.dropdowns.CAR_PUBLIC);
      setDropdownCar(props.dropdowns.CAR_MY);
    }
  }, [props.dropdowns]);

  useEffect(() => {
    console.log('CHANGE');
    console.log(props.item);
    if (props.item) {
      downloadCrWs();
      downloadExpendWs(props.item.planid);
      downloadChatWs(props.item.planid);
      downloadPhotoWs(props.item.planid);

      downloadPhotoNaWs(props.item.planid);

      downloadPathWs(props.item.planid);
      setDropdownApvPlan(props.item.apvPlanid);
      setDropdownApvIbc(props.item.apvPlanIbcid);
      setDropdownApvActual(props.item.apvActualid);
      downloadPlaceWs(props.item.planid);
      downloadDriverWs(props.item.planid);
      setPlan((prevState) => ({
        ...prevState,
        vehicleid: props.item.vehicleid,
        distanceActual: props.item.distanceActual / 1000,
        totaCostActual: props.item.totaCostActual,
        rate: props.item.rate
      }));
      //   downloadApvWs(props.item.planid);
    }
  }, [props.item]);

  const [openModal, setOpenModal] = useState(false);
  const [selectedRating, setSelectedRating] = useState(null);
  const formUrl = props.item
  ? `https://docs.google.com/forms/d/e/1FAIpQLSdPvgJIKJPlrwpYjrkZ9dU9ZSINnVmBwMqmcIY0nOHdoZ0hQA/viewform?usp=pp_url&entry.1223500353=${props.item.planid}`
  : '';


  const handleRating = async (rate) => {
    setSelectedRating(rate);
    setOpenModal(true);
    // if (props.item) {
    //   setLoading(true);
    //   let input = {
    //     planid: props.item.planid,
    //     totaCostActual: props.item.totaCostActual,
    //     doRate: true,
    //     rating: rate,
    //     system: props.item.system
    //   };
    //   await updatePlanWs(input);
    //   await props.onRefresh(props.item.planid);
    //   setLoading(false);
    // }
  };

  const handleSubmitSurvey = async () => {
    if (!props.item) return;
    setLoading(true);
    // --- 1) ส่งไป Google Sheet ---
    // await fetch('YOUR_GOOGLE_SCRIPT_URL', {
    //   method: 'POST',
    //   body: JSON.stringify({
    //     planid: props.item.planid,
    //     rating: selectedRating
    //     // เดี๋ยวเราจะเพิ่มค่าฟอร์มในภายหลัง
    //   })
    // });
    // --- 2) update ระบบเดิม ---
    const input = {
      planid: props.item.planid,
      totaCostActual: props.item.totaCostActual,
      doRate: true,
      rating: selectedRating,
      system: props.item.system
    };

    await updatePlanWs(input);
    await props.onRefresh(props.item.planid);

    setLoading(false);
    setOpenModal(false);
    alert('ส่งแบบประเมินความพึงพอใจเรียบร้อย');
  };

  const handleCrCancel = async () => {
    if (props.item) {
      setLoading(true);
      const input = {
        planid: props.item.planid,
        crCanceled: 'me',
        system: props.item.system
      };
      await updatePlanWs(input);
      await props.onRefresh(props.item.planid);
      setLoading(false);

      setOpenModal(false);

      alert('ส่งแบบประเมินความพึงพอใจเรียบร้อย');
    }
  };

  const getVdoWs = async (url) => {
    try {
      const vdos = await AuthService.getVdoWs(url);
      return vdos.result;
    } catch (error) {
      return [];
    }
  };

  const StyledUserImage = styled(PfImage)``;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const downloadCrWs = async () => {
    try {
      const show = await AuthService.downloadCrWs();
      if (show.error) toast.error(show.error);
      setShow(show.value);
    } catch (error) {}
  };

  const uploadPicWs = async (input, file) => {
    try {
      const photo = await AuthService.uploadPicWs(input, file);
      setPhoto(photo);
      setShowMd4(false);
      if (photo.error) toast.error(photo.error);
    } catch (error) {}
  };

  const uploadPicWs2 = async (input, file) => {
    try {
      const photo = await AuthService.uploadPicWs2(input, file);
      setPhoto(photo);
      setShowMd5(false);
      if (photo.error) toast.error(photo.error);
    } catch (error) {}
  };

  const importPhotoNa = async () => {
    try {
      await AuthService.importPhotoNa(
        props.item.planid,
        photoNa.filter((e) => e.selected)
      );
      await props.onRefresh(props.item.planid);
    } catch (error) {}
  };

  const onValueChange = (index, value) => {
    const temp = dropdownExpend.map((e) => {
      if (e.value === index) return {...e, amount: parseInt(value)};
      return e;
    });
    setDropdownExpend(temp, (selected) => {
      const sum = selected
        .filter((e) => e.cal === true)
        .reduce((prev, curr) => prev + curr.amount, 0);
      setPlan((prevState) => ({
        ...prevState,
        totalExpend: sum
      }));
    });
  };

  const downloadExpendWs = async (planid) => {
    try {
      const expends = await AuthService.downloadExpendCar(planid);
      console.log(expends);
      if (expends.error) throw 'timeout';

      setDropdownExpend(expends.EXPEND, (selected) => {
        const sum = selected
          .filter((e) => e.cal === true)
          .reduce((prev, curr) => prev + curr.amount, 0);
        setPlan((prevState) => ({
          ...prevState,
          totalExpend: sum
        }));
      });
    } catch (error) {
      console.log('exit expend');
      props.onHide();
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };

  const downloadDriverWs = async (planid) => {
    try {
      const driver = await AuthService.getDriver(planid);
      if (driver.error) throw 'timeout';
      setDriver(driver);
    } catch (error) {
      console.log('exit driver');
      props.onHide();
      dispatch(logoutUser());
      window.location.href = '/login';
    }
  };

  const downloadPlaceWs = async (planid) => {
    try {
      const places = await AuthService.downloadPlace(planid, 'plan');
      console.log(places);
      if (places.error) throw 'timeout';

      if (places.filter((e) => e.type === 'plan').length === 1)
        setPlaces(places.filter((e) => e.type === 'plan')[0].places);
      if (places.filter((e) => e.type === 'actual').length === 1) {
        setPlacesActual(places.filter((e) => e.type === 'actual')[0].places);
      } else {
        setPlacesActual([]);
      }
    } catch (error) {
      console.log('exit place');
      props.onHide();
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };

  const downloadPhotoWs = async (planid) => {
    try {
      const photo = await AuthService.downloadPhoto(planid);
      console.log(photo);
      if (photo.error) throw 'timeout';
      setPhoto(photo);
    } catch (error) {
      console.log('exit photo');
      props.onHide();
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };

  const downloadPhotoNaWs = async (planid) => {
    try {
      const photo = await AuthService.downloadPhotoNa(planid);
      if (photo.error) throw 'timeout';
      setPhotoNa(photo.map((e) => ({...e, selected: false})));
    } catch (error) {
      console.log('exit photo');
      props.onHide();
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };

  const downloadPathWs = async (planid) => {
    try {
      const path = await AuthService.downloadPath(planid);
      if (path.error) throw 'timeout';
      setApprovePath(
        path.map((e, i) => {
          return {
            ...e,
            href: '#',
            onClick: (e) => {
              e.preventDefault();
              onSendMessage(props.item ? `#APV-${i}` : 'ERROR');
              console.log('onClick', i);
            }
          };
        })
      );

      // ตั้งค่า panel
      setPanel((prevState) => ({
        ...prevState,
        isMe: props.item.staffid === user.ID_EMP,
        isEditable:
          props.item.status === 'reject' && props.item.rejectNumber === 1,
        isCancelable:
          path.filter((e) => e.status === '').length === path.length - 1,
        isApprovable: path.find((e) => e.status === '')
          ? path.find((e) => e.status === '').members.includes(user.ID_EMP)
          : false,
        isRejectable: path.find((e) => e.status === '')
          ? path.find((e) => e.status === '').members.includes(user.ID_EMP)
          : false
      }));
    } catch (error) {
      console.log('exit path');
      props.onHide();
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };

  const downloadChatWs = async (planid) => {
    try {
      const chats = await AuthService.downloadChat(planid);
      if (chats.error) throw 'timeout';
      setChat(chats);
    } catch (error) {
      console.log('exit chat');
      props.onHide();
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };
  const uploadChatWs = async (planid, message) => {
    try {
      const chats = await AuthService.uploadChat(planid, message);
      if (chats.error) throw 'timeout';
      setChat(chats);
    } catch (error) {
      console.log('exit chat');
      props.onHide();
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };
  const updatePlanWs = async (input) => {
    try {
      const result = await AuthService.updatePlan(input);
      if (result.result === 'SUCCESS') toast.success('ปรับปรุงข้อมูลแล้ว');
      else toast.error('ปรับปรุงข้อมูลผิดพลาด');
    } catch (error) {}
  };
  const updateExpendWs = async (input) => {
    try {
      const result = await AuthService.updateExpend(input);
      if (result.result === 'SUCCESS') toast.success('ปรับปรุงข้อมูลแล้ว');
      else toast.error('ปรับปรุงข้อมูลผิดพลาด');
    } catch (error) {}
  };
  const updatePlanApproveWs = async (input) => {
    try {
      const result = await AuthService.updatePlanApprove(input);
      if (result.result === 'SUCCESS') toast.success('ปรับปรุงข้อมูลแล้ว');
      else toast.error('ปรับปรุงข้อมูลผิดพลาด');
      await props.onRefresh(input.planid);
    } catch (error) {}
  };
  const recalWs = async (planid) => {
    try {
      setLoading(true);
      const cal = await AuthService.recal(planid);
      if (cal.error) throw 'timeout';
      console.log('MOO-RECAL FIN');
      // ไม่ปิด popup
      // props.onHide();
      // refresh table
      await props.onRefresh(planid);
      setLoading(false);
    } catch (error) {
      console.log('exit cal');
      props.onHide();
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };
  const [key, setKey] = useState('plan');

  const dropdownType = [
    {value: '1', label: 'รถส่วนตัว (cdsexp)'},
    {value: '2', label: 'รถบริการ (carservice)'}
  ];

  const [show, setShow] = useState(false);
  const [panel, setPanel] = useState({
    isMe: false,
    isCancelable: false,
    isEditable: false,
    isApprovable: false,
    isRejectable: false
  });
  const [style, setStyle] = useState('lightbox');
  const [dropdownCar, setDropdownCar] = useState({DATA: []});
  const [dropdownCarPublic, setDropdownCarPublic] = useState({DATA: []});
  const [chat, setChat] = useState([]);
  const [photo, setPhoto] = useState([
    {
      src: `https://cdn-icons-png.flaticon.com/512/911/911033.png`,
      original: `https://cdn-icons-png.flaticon.com/512/911/911033.png`,
      downloadUrl: `https://cdn-icons-png.flaticon.com/512/911/911033.png`,
      caption: `TEMP`,
      alt: `TEMP`
    }
  ]);

  const [photoNa, setPhotoNa] = useState([
    {
      selected: false,
      src: `https://cdn-icons-png.flaticon.com/512/911/911033.png`,
      original: `https://cdn-icons-png.flaticon.com/512/911/911033.png`,
      downloadUrl: `https://cdn-icons-png.flaticon.com/512/911/911033.png`,
      caption: `TEMP`,
      alt: `TEMP`
    }
  ]);
  //   const [plan, setPlan] = useState({
  //     vehicleid: {value: '', label: 'เลือกยานพาหนะ'}
  //   });

  const [plan, setPlan] = useState({
    vehicleid: {value: '', label: 'เลือกยานพาหนะ'},
    totalExpend: 0,
    distanceActual: 0,
    totaCostActual: 0,
    rate: 0
  });
  const [showMd4, setShowMd4] = useState(false);
  const [showMd5, setShowMd5] = useState(false);

  const [places, setPlaces] = useState([]);
  const [placesActual, setPlacesActual] = useState([]);
  const [approvePath, setApprovePath] = useState([]);
  const [marker, setMarker] = useState([]);
  const [dropdownCompany, setDropdownCompany] = useState({DATA: []});
  const [dropdownCostcenter, setDropdownCostcenter] = useState({DATA: []});
  const [dropdownExpend, setDropdownExpend] = useStateWithCallbackLazy([]);
  const [dropdownApvPlan, setDropdownApvPlan] = useState({});
  const [dropdownApvIbc, setDropdownApvIbc] = useState({});
  const [dropdownApvActual, setDropdownApvActual] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [driver, setDriver] = useState({});

  const onAgree = async () => {
    await updatePlanApproveWs({
      planid: props.item.planid,
      system: props.item.system,
      status: 'approve'
    });
    await props.onRefresh(props.item.planid);
    props.onHide();
  };

  const onReject = async () => {
    await updatePlanApproveWs({
      planid: props.item.planid,
      system: props.item.system,
      status: 'reject'
    });
    await props.onRefresh(props.item.planid);
    props.onHide();
  };
  const onEdit = async () => {
    await updatePlanApproveWs({
      planid: props.item.planid,
      system: props.item.system,
      status: 'edit'
    });
    await updatePlanWs({
      planid: props.item.planid,
      vehicleid: plan.vehicleid,
      system: props.item.system
    });
    await props.onRefresh(props.item.planid);
    props.onHide();
  };
  const onCancel = async () => {
    await updatePlanWs({
      planid: props.item.planid,
      status: 'cancel',
      system: props.item.system
    });
    await props.onRefresh(props.item.planid);
    props.onHide();
  };
  const onRecal = async () => {
    if (props.item) {
      console.log(props.item.planid);
      await recalWs(props.item.planid);
    }
  };

  const onAdjust = async () => {
    if (props.item) {
      let input = {
        vehicleid: plan.vehicleid,
        planid: props.item.planid,
        totalExpend: plan.totalExpend,
        distanceActual: plan.distanceActual * 1000,
        totaCostActual: plan.totaCostActual,
        system: props.item.system
      };
      await updatePlanWs(input);
      input = {planid: props.item.planid, expends: dropdownExpend};
      await updateExpendWs(input);
      await props.onRefresh(props.item.planid);
    }
  };

  const onUpload = async (file) => {
    if (props.item) {
      const input = {
        planid: props.item.planid
      };
      await uploadPicWs(input, file);
      await props.onRefresh(props.item.planid);
    }
  };

  const onUpload2 = async (file) => {
    if (props.item) {
      const input = {
        planid: props.item.planid,
        datetime: file.datetime,
        location: file.location
      };
      await uploadPicWs2(input, file);
      await props.onRefresh(props.item.planid);
    }
  };

  const onChangeKm = async (value) => {
    if (props.item) {
      setPlan((prevState) => ({
        ...prevState,
        distanceActual: value,
        totaCostActual: value * plan.rate
      }));
    }
  };

  const onPlanChange = async (input) => {
    await updatePlanWs(input);
    await props.onRefresh(props.item.planid);
  };

  const onSendMessage = async (message) => {
    if (props.item) {
      await uploadChatWs(props.item.planid, message);
    }
  };

  const setNewSelected = (v) => {
    console.log(v);
    v = v.map((e) => {
      return {...e, selected: true};
    });
    setDropdownExpend(v, (selected) => {
      const sum = selected
        .filter((e) => e.cal === true)
        .reduce((prev, curr) => prev + curr.amount, 0);
      setPlan((prevState) => ({
        ...prevState,
        totalExpend: sum
      }));
    });
  };

  return (
    <div className="row">
      <Modal
        show={showMd4}
        onHide={() => setShowMd4(false)}
        style={{zIndex: 9999}}
      >
        <Modal.Header closeButton>
          <Modal.Title>อัพโหลดรูปเพิ่มเติม</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalAddPic onUpload={onUpload} />
        </Modal.Body>
      </Modal>
      <Modal
        show={showMd5}
        onHide={() => setShowMd5(false)}
        style={{zIndex: 9999}}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            อัพโหลดรูปเพิ่มเติมแบบระบุวันเวลา และพิกัด GPS
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalAddPicGps onUpload={onUpload2} />
        </Modal.Body>
      </Modal>
      <div className="col-12 col-md-9">
        <Card className="bg-light">
          <Stepper
            // activeColor={
            //   approvePath.filter((e) => e.status === 'reject').length >= 1
            //     ? '#bb392d'
            //     : '#42997f'
            // }
            size={64}
            activeColor="#f8f9fa"
            completeColor="#f8f9fa"
            defaultColor="#f8f9fa"
            titleFontSize={12}
            circleFontSize={14}
            steps={approvePath}
            activeStep={
              approvePath.filter((e) => e.status === 'approve').length ===
              approvePath.length
                ? approvePath.length - 1
                : approvePath.filter((e) => e.status === 'approve').length
            }
          />
        </Card>
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
        >
          <Tab eventKey="plan" title="ข้อมูล">
            <div className="row">
              <div className="row col-md-9 col-12">
                <Form.Group className="mb-3 col-md-4">
                  <Form.Label>พนักงาน</Form.Label>
                  <Form.Control
                    type="text"
                    value={props.item ? props.item.staff : ''}
                    disabled
                  />
                </Form.Group>
                <Form.Group className="mb-3 col-md-4">
                  <Form.Label>ประเภทการเดินทาง</Form.Label>
                  <Form.Control
                    type="text"
                    value={props.item ? props.item.typeid.label : ''}
                    disabled
                  />
                </Form.Group>
                <Form.Group className="mb-3 col-md-4">
                  <Form.Label>เลือกรถ</Form.Label>
                  <Select
                    isDisabled={
                      props.item
                        ? props.item.status === 'reject' &&
                          props.item.rejectNumber === 1
                          ? false
                          : props.mode === 'read'
                        : true
                    }
                    value={plan.vehicleid}
                    options={
                      props.item
                        ? props.item.typeid.value === '1'
                          ? dropdownCar.DATA
                          : dropdownCarPublic.DATA
                        : []
                    }
                    onChange={(v) => {
                      setPlan((prevState) => ({
                        ...prevState,
                        vehicleid: v
                      }));
                    }}
                  />
                </Form.Group>
                <Form.Group className="mb-3 col-md-4">
                  <Form.Label>วันเวลาที่เดินทางไป</Form.Label>
                  <Form.Control
                    type="text"
                    value={props.item ? props.item.date_start : ''}
                    disabled
                  />
                </Form.Group>
                <Form.Group
                  className={
                    props.item
                      ? props.item.typeid.value === '1'
                        ? 'mb-3 col-md-4 d-none'
                        : 'mb-3 col-md-4'
                      : 'mb-3 col-md-4'
                  }
                >
                  <Form.Label>วันเวลาที่เดินทางกลับ</Form.Label>
                  <Form.Control
                    type="text"
                    value={props.item ? props.item.date_stop : ''}
                    disabled
                  />
                </Form.Group>
                <Form.Group className="mb-3 col-md-12">
                  <Form.Control
                    as="textarea"
                    disabled
                    value={props.item ? props.item.objective : ''}
                    placeholder="วัตถุประสงค์"
                  />
                </Form.Group>
              </div>
              <div className="col-md-3 col-12 text-center">
                <div className="mb-2">
                  <strong>รูปรถ (กรณีรถส่วนตัว)</strong>
                </div>
                <a
                  target="_blank"
                  href={
                    props.item
                      ? props.item.vehicleid.image.replace('?size=300', '_CAR')
                      : '#'
                  }
                  rel="noreferrer"
                >
                  <img
                    className="car-img"
                    src={
                      props.item
                        ? props.item.vehicleid.image.replace(
                            '?size=300',
                            '_CAR?size=300'
                          )
                        : ''
                    }
                  />
                </a>
              </div>

              <Form.Group className="mb-3 col-md-6">
                <Select
                  isDisabled={props.mode === 'read'}
                  placeholder="บริษัทรับทราบค่าใช้จ่าย"
                  value={props.item ? props.item.companyid : {}}
                  options={dropdownCompany.DATA}
                  onChange={(v) => {}}
                />
              </Form.Group>
              <Form.Group className="mb-3 col-md-6">
                <Select
                  isDisabled={props.mode === 'read'}
                  value={props.item ? props.item.costid : {}}
                  placeholder="cost center"
                  options={
                    !props.item
                      ? dropdownCostcenter.DATA
                      : dropdownCostcenter.DATA.filter(
                          (e) => e.company === props.item.companyid.value
                        )
                  }
                  onChange={(v) => {}}
                />
              </Form.Group>
              <Form.Group className="mb-3 col-md-4">
                <Select
                  isDisabled
                  value={dropdownApvPlan}
                  placeholder="เลือกผู้อนุมัติแผน"
                  options={[]}
                  formatOptionLabel={(e) => (
                    <div className="d-flex">
                      <StyledUserImage
                        src={e.image}
                        fallbackSrc="/img/default-profile.png"
                        width={34}
                        height={34}
                        rounded
                      />
                      <span className="align-self-center ml-2">{e.label}</span>
                    </div>
                  )}
                />
              </Form.Group>
              <Form.Group className="mb-3 col-md-4">
                <Select
                  isDisabled
                  value={dropdownApvIbc}
                  placeholder="เลือก IBC"
                  options={[]}
                  formatOptionLabel={(e) => (
                    <div className="d-flex">
                      <StyledUserImage
                        src={e.image}
                        fallbackSrc="/img/default-profile.png"
                        width={34}
                        height={34}
                        rounded
                      />
                      <span className="align-self-center ml-2">{e.label}</span>
                    </div>
                  )}
                />
              </Form.Group>
              <Form.Group className="mb-3 col-md-4">
                <Select
                  isDisabled
                  value={dropdownApvActual}
                  placeholder="เลือกผู้อนุมัติผล"
                  options={[]}
                  formatOptionLabel={(e) => (
                    <div className="d-flex">
                      <StyledUserImage
                        src={e.image}
                        fallbackSrc="/img/default-profile.png"
                        width={34}
                        height={34}
                        rounded
                      />
                      <span className="align-self-center ml-2">{e.label}</span>
                    </div>
                  )}
                />
              </Form.Group>
              <Form.Group className="mb-3 col-md-5">
                <Select
                  isMulti
                  isDisabled={!show}
                  value={dropdownExpend.filter((e) => e.selected === true)}
                  menuPlacement="top"
                  options={
                    props.dropdowns.EXPEND ? props.dropdowns.EXPEND.DATA : []
                  }
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="ค่าใช้จ่ายอื่นๆ"
                  onChange={(v) => {
                    setNewSelected(v);
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3 col-md-2">
                <Form.Control
                  type="number"
                  placeholder="(บาท)"
                  disabled
                  //   value={props.item ? props.item.totalExpend : 0}
                  value={plan.totalExpend}
                />
              </Form.Group>
              <Form.Group className="mb-3 col-md-5">
                <SelectedBox
                  isDisabled={!show}
                  onValueChange={onValueChange}
                  selected={dropdownExpend}
                />
              </Form.Group>
            </div>
          </Tab>

          {/* <Tab eventKey="map" title="แผนที่">
            <div className="row">
              <div
                className="col-12 col-md-9"
                style={{
                  height: '55vh',
                  width: '100%',
                  paddingBottom: '5vh'
                }}
              >
                <Map
                  places={places}
                  //   id={props.item ? props.item.planid : 0}
                  key={
                    props.item
                      ? `modalitem-map-${props.item.planid}`
                      : 'modalitem-map-0'
                  }
                ></Map>
              </div>
              <div className="col-12 col-md-3">
                <Card className="card-primary">
                  <div
                    className="container"
                    style={{
                      height: '42vh',
                      width: '100%',
                      overflowY: 'scroll'
                    }}
                  >
                    {places.map((e, index, array) => (
                      <div
                        className="col-12 mt-2"
                        key={`modalitem-card-${index}`}
                      >
                        <div className="info-box-drag">
                          <div className="row">
                            <span className="info-box-icon">
                              <div className="numberCircle">
                                {array.length > 24
                                  ? index + 1
                                  : String.fromCharCode(index + 65)}
                              </div>
                            </span>
                            <div className="info-box-content">
                              <span className="info-box-text">{`${Number(
                                e.lat
                              ).toFixed(4)} , ${Number(e.lng).toFixed(
                                4
                              )}`}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <Card.Footer>
                    <div className="d-flex justify-content-between">
                      <div className="p-2">
                        {props.item
                          ? (props.item.distance / 1000).toFixed(2)
                          : '0'}{' '}
                        Km.
                      </div>
                      <div className="p-2">
                        {props.item
                          ? ((props.item.distance / 1000) * 5.5).toFixed(2)
                          : '0'}{' '}
                        บาท
                      </div>
                    </div>
                  </Card.Footer>
                </Card>
              </div>
            </div>
          </Tab> */}

          <Tab eventKey="gallery" title={`รูปถ่าย (${photo.length})`}>
            <PhotoStamp images={photo} style={style} setStyle={setStyle} />
          </Tab>
          <Tab eventKey="cockpit" title="cockpit">
            <div className={isLoading ? 'overlay dark' : 'd-none'}>
              <ClockLoader color="#c4c4c4" />
            </div>
            <div className="row">
              <div className="row col-md-8 col-12">
                <Form.Group className="col-md-4">
                  <Form.Control
                    type="text"
                    value={props.item ? props.item.staff : ''}
                    disabled
                  />
                </Form.Group>
                <Form.Group className="col-md-4">
                  <Form.Control
                    type="text"
                    value={props.item ? props.item.date_start : ''}
                    disabled
                  />
                </Form.Group>
                <Form.Group
                  className={
                    props.item
                      ? props.item.typeid.value === '1'
                        ? 'col-md-4 d-none'
                        : 'col-md-4'
                      : 'col-md-4'
                  }
                >
                  <Form.Control
                    type="text"
                    value={props.item ? props.item.date_stop : ''}
                    disabled
                  />
                </Form.Group>
                <Form.Group className="col-md-12">
                  <Form.Control
                    as="textarea"
                    disabled
                    value={props.item ? props.item.objective : ''}
                    placeholder="วัตถุประสงค์"
                  />
                </Form.Group>
                {/* <Form.Group className="mb-3 col-md-9">
                  <Select
                    isMulti
                    isDisabled={true}
                    value={dropdownExpend}
                    menuPlacement="top"
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder={'ค่าใช้จ่ายอื่นๆ'}
                    options={[]}
                  />
                </Form.Group> */}
                <Form.Group className="col-md-4">
                  <Form.Control
                    type="text"
                    value={props.item ? props.item.typeid.label : ''}
                    disabled
                  />
                </Form.Group>
                <Form.Group className="col-md-4">
                  <Select
                    isDisabled={!show}
                    // isDisabled={props.mode === 'read'}
                    value={plan.vehicleid}
                    // value={props.item ? props.item.vehicleid : {}}
                    options={
                      props.item
                        ? props.item.typeid.value === '1'
                          ? dropdownCar.DATA
                          : dropdownCarPublic.DATA
                        : []
                    }
                    onChange={(v) => {
                      setPlan((prevState) => ({
                        ...prevState,
                        vehicleid: v
                      }));
                    }}
                  />
                </Form.Group>
                <Form.Group className="col-md-4">
                  <Form.Control
                    type="text"
                    value={props.item ? props.item.siteid.label : ''}
                    disabled
                  />
                </Form.Group>
              </div>
              <div className="col-md-2 col-12 text-center">
                <div className="mb-2">
                  <strong>รูปรถ</strong>
                </div>
                <a
                  target="_blank"
                  href={
                    props.item
                      ? props.item.vehicleid.image.replace('?size=300', '_CAR')
                      : '#'
                  }
                  rel="noreferrer"
                >
                  <img
                    className="car-img2"
                    src={
                      props.item
                        ? props.item.vehicleid.image.replace(
                            '?size=300',
                            '_CAR?size=300'
                          )
                        : ''
                    }
                    alt=""
                  />
                </a>
              </div>
              <div className="col-md-2 col-12 text-center">
                <div className="mb-2">
                  <strong>รูปเล่มรถ</strong>
                </div>
                <a
                  target="_blank"
                  href={
                    props.item
                      ? props.item.vehicleid.image.replace('?size=300', '_DOC')
                      : '#'
                  }
                  rel="noreferrer"
                >
                  <img
                    className="car-img2"
                    src={
                      props.item
                        ? props.item.vehicleid.image.replace(
                            '?size=300',
                            '_DOC?size=300'
                          )
                        : ''
                    }
                    alt=""
                  />
                </a>
              </div>
              <div className="col-md-12 col-12">
                <hr />
              </div>
              <div className="col-md-6 col-12">
                <MapAndInfo
                  expend={plan.totalExpend}
                  show
                  item={props.item ? props.item : null}
                  type="plan"
                  places={places}
                />
              </div>
              <div className="col-md-6 col-12">
                <MapAndInfo
                  plan={plan}
                  onChangeKm={onChangeKm}
                  show={show}
                  onAdjust={onAdjust}
                  onPlanChange={onPlanChange}
                  onRecal={onRecal}
                  item={props.item ? props.item : null}
                  type="actual"
                  places={placesActual}
                  getVdoWs={getVdoWs}
                />
              </div>
            </div>
          </Tab>

          <Tab eventKey="galleryNa" title={`รูปถ่ายนอกแผน (${photoNa.length})`}>
            <PhotoStamp
              mode="select"
              images={photoNa}
              setPhotoNa={setPhotoNa}
              importPhotoNa={importPhotoNa}
              style={style}
              setStyle={setStyle}
            />
          </Tab>

          <Tab
            eventKey="driver"
            title="คนขับรถบริการ"
            disabled={
              props.item
                ? props.item.typeid.value !== '2' &&
                  props.item.typeid.value !== '4'
                : true
            }
          >
            <div className={isLoading ? 'overlay dark' : 'd-none'}>
              <ClockLoader color="#c4c4c4" />
            </div>
            <div className="row">
              <div className="row col-md-8 col-12">
                <Form.Group className="col-md-6">
                  <Form.Label>ชื่อคนขับ</Form.Label>
                  <Form.Control
                    type="text"
                    value={
                      Object.keys(driver).length === 0
                        ? 'ไม่พบข้อมูล'
                        : driver.NAME
                    }
                    disabled
                  />
                </Form.Group>
                <Form.Group className="col-md-6">
                  <Form.Label>เบอร์โทร</Form.Label>
                  <Form.Control
                    type="text"
                    value={
                      Object.keys(driver).length === 0
                        ? 'ไม่พบข้อมูล'
                        : driver.PHONE
                    }
                    disabled
                  />
                </Form.Group>
                <Form.Group className="col-md-6">
                  <Form.Label>ประเภทรถ</Form.Label>
                  <Form.Control
                    type="text"
                    value={
                      Object.keys(driver).length === 0
                        ? 'ไม่พบข้อมูล'
                        : driver.TYPE
                    }
                    disabled
                  />
                </Form.Group>
                <Form.Group className="col-md-6">
                  <Form.Label>ทะเบียน</Form.Label>
                  <Form.Control
                    type="text"
                    value={
                      Object.keys(driver).length === 0
                        ? 'ไม่พบข้อมูล'
                        : driver.PLATE_NO
                    }
                    disabled
                  />
                </Form.Group>
              </div>
              <div className="col-md-2 col-12 text-center">
                <div className="mb-2">
                  <strong>รูปรถ</strong>
                </div>
                <a
                  target="_blank"
                  href={
                    Object.keys(driver).length === 0
                      ? '#'
                      : driver.IMG_CAR.replaceAll('?size=300', '')
                  }
                  rel="noreferrer"
                >
                  <img
                    className="car-img2"
                    src={Object.keys(driver).length === 0 ? '' : driver.IMG_CAR}
                    alt=""
                  />
                </a>
              </div>
              <div className="col-md-2 col-12 text-center">
                <div className="mb-2">
                  <strong>รูปคนขับ</strong>
                </div>
                <a
                  target="_blank"
                  href={
                    Object.keys(driver).length === 0
                      ? '#'
                      : driver.IMG_DRIVER.replaceAll('?size=300', '')
                  }
                  rel="noreferrer"
                >
                  <img
                    className="car-img2"
                    src={
                      Object.keys(driver).length === 0 ? '' : driver.IMG_DRIVER
                    }
                    alt=""
                  />
                </a>
              </div>
            </div>
          </Tab>
        </Tabs>
        <p className="text-danger col-md-12">{error}</p>
      </div>
      <div className="col-12 col-md-3">
        <DirectChat
          isPublic={
            props.item ? props.item.vehicleid.value === '0' || show : false
          }
          onOpenUpload={setShowMd4}
          onOpenUploadGps={setShowMd5}
          panel={panel}
          messages={chat}
          onAgree={onAgree}
          onReject={onReject}
          onEdit={onEdit}
          onCancel={onCancel}
          onSendMessage={onSendMessage}
        />

        <Card className="card-primary">
          <div className={isLoading ? 'overlay dark' : 'd-none'}>
            <ClockLoader color="#c4c4c4" />
          </div>

          <Rating
            className="m-2"
            onClick={handleRating}
            tooltipArray={tooltipArray}
            showTooltip
            size={35}
            tooltipDefaultText="ประเมิน"
            initialValue={props.item ? props.item.rating : null}
          />
        </Card>

        <SurveyModal open={openModal} onClose={() => setOpenModal(false)}>
          <h3>แบบประเมินเพิ่มเติม</h3>
          <p>กรุณาเลือกคะแนนเพิ่มเติมในแต่ละหัวข้อ</p>
          <iframe
            src={formUrl}
            width="640"
            height="540"
            frameBorder="0"
          >
            กำลังโหลด…
          </iframe>
          {/* แนะนำผู้ใช้ */}
          <p style={{marginTop: 12, fontStyle: 'italic', color: '#555'}}>
            *กรุณากดปุ่มส่งของ Google Form ก่อน แล้วกดปุ่ม “ส่งข้อมูล”
            ด้านล่างเพื่ออัปเดตระบบ
          </p>

          {/* ปุ่มระบบเดิม */}
          <button className={styles['btn-submit']} onClick={handleSubmitSurvey}>
            ส่งข้อมูล
          </button>
        </SurveyModal>

        <Card className="card-primary">
          <div className={isLoading ? 'overlay dark' : 'd-none'}>
            <ClockLoader color="#c4c4c4" />
          </div>
          <div className="row m-2">
            <Form.Group className="col-md-8 col-12 m-0">
              <Form.Control
                as="textarea"
                disabled
                style={{fontSize: 12}}
                value={
                  props.item
                    ? props.item.crCanceled
                      ? props.item.crCanceled.length > 0
                        ? props.item.crCanceled
                        : ''
                      : ''
                    : ''
                }
                placeholder={`รายชื่อ cr \n(cr ต้องกดยกเลิก 2 คนขึ้นไป)`}
              />
            </Form.Group>
            <Button
              onClick={handleCrCancel}
              className="col-md-4 col-12 m-0"
              variant="danger"
              disabled={!show}
            >
              CR ยกเลิก
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
}
